module.exports = __webpack_public_path__ + "static/media/newFacebook.2b2d712b.svg";